<se-fe-chip id="{{ id() }}" [seFeDataText]="text()" [seFeDataStyle]="style()" seFeDataIconLeft="dot_fill"></se-fe-chip>
